<template>
  <footer class="container px-4 py-4 mx-auto mb-2 text-sm max-w-7xl sm:px-6 lg:px-8">
    Copyright {{ year }} The Post Office
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
